import { useMemo } from 'react'
import { OptionType, ScheduleType } from 'types/schedule'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'

const useExtractOptions = (schedules: ScheduleType[], storeDeliveryBread: StoreDeliveryBreadType): OptionType[] => {
  return useMemo(() => {
    const schedule = schedules[0]
    if (schedule) return schedule.options
    if (storeDeliveryBread) return storeDeliveryBread.options
    return []
  }, [schedules, storeDeliveryBread])
}

export default useExtractOptions
